import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { AuthService } from '../shared/auth.service';
import { Router, CanActivate } from '@angular/router';

@Component({
    selector: 'admin-logged-out',
    template: require('./partials/admin-login.component.html'),
})
export class AdminLoginComponent implements OnInit {

    public credentials: Object = {
        username: null,
        password: null
    };

    constructor(private location: Location, public router: Router, private authService: AuthService){
    }

    ngOnInit(){
        this.authService.logout();
    }

    login(credentials: Object){
        this.authService.login(credentials)
            .then(response => {
                this.router.navigate(['admin']);
            });
    }
    
} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/admin/admin-login.component.ts